var _path, _mask, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2285 8.62646C20.9139 7.04703 25.0861 7.04703 28.7715 8.62646C29.0619 8.751 29.25 9.03704 29.25 9.35303V26.7554C29.25 26.9656 29.0351 27.1077 28.8418 27.0249C25.1114 25.4262 20.8886 25.4262 17.1582 27.0249L16 27.521L14.8418 27.0249C11.1114 25.4262 6.88857 25.4262 3.1582 27.0249C2.96492 27.1077 2.75 26.9656 2.75 26.7554V9.35303C2.75 9.03705 2.93812 8.751 3.22852 8.62646C6.91386 7.04703 11.0861 7.04703 14.7715 8.62646L15.7041 9.02686L16 9.15381L16.2959 9.02686L17.2285 8.62646Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4729_17029",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11.3374,
    width: 8,
    height: 11,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11.3374,
    width: 8,
    height: 11,
    rx: 1,
    stroke: "black",
    strokeWidth: 3,
    mask: "url(#path-2-inside-1_4729_17029)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12.3374,
    width: 8,
    height: 1.5,
    rx: 0.75,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16.3374,
    width: 8,
    height: 1.5,
    rx: 0.75,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20.3374,
    width: 8,
    height: 1.5,
    rx: 0.75,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/Blog.102cf2a24f5b41855d3dcad6d054db3a.svg";
export { ForwardRef as ReactComponent };